<template>
  <v-container grid-list-md>
    <utility-backButton />
    <v-layout row wrap>
      <!-- Email Dialog box -->
      <v-dialog v-model="emailDialog" persistent max-width="800px">
        <widget-emailForm :userToEmail="userToEmail" @closeDialog="emailDialog = false" />
      </v-dialog>
      <!-- =====END==== -->

      <!-- Date pickers and button -->
      <v-flex xs12 sm6 md4 lg4>
        <v-date-picker v-model="fromDate">
          <v-text-field
            box
            slot-scope="props"
            label="From"
            v-model="props.inputValue"
            append-icon="mdi-calendar-range"
            readonly
          ></v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs12 sm6 md4 lg4>
        <v-date-picker v-model="toDate">
          <v-text-field
            slot-scope="props"
            label="To"
            v-model="props.inputValue"
            append-icon="mdi-calendar-range"
            readonly
            box
          ></v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs6 md4>
        <div class="text-xs-left">
          <v-btn
            color="pipefishOrange"
            outline
            class="elevation-1"
            @click="getEntries"
            :loading="applyClicked"
            :disabled="applyClicked"
          >Apply Dates</v-btn>
        </div>
      </v-flex>
      <!-- ====END=== -->

      <v-flex xs6>
        <v-select
          dense
          :items="[{text: 'Active', value: false},
          {text: 'InActive', value: true},
          {text: 'Both', value: 'Both'}]"
          label="Filter on"
          v-model="filterActive"
          hint="after selecting click apply dates again"
        ></v-select>
      </v-flex>

      <v-flex xs12>
        <v-card-title slot="header" class="title font-weight-bold" style="padding: 0px 0px 5px 0px">
          Timesheet Summaries
          <v-spacer></v-spacer>
          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search name"
              color="pipefishGreen"
            ></v-text-field>
          </div>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          sort-by="name"
          sort-icon="mdi-menu-down"
          item-key="name"
          hide-actions
        >
          <template slot="headerCell" slot-scope="{ header }">
            <span class="subheading font-weight-bold text--darken-3" v-text="header.text"></span>
          </template>
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td>
                <span @click="gotoTimesheets(props.item.id, props.item.name)">
                  <a>{{props.item.name}}</a>
                </span>
              </td>
              <td>{{props.item.days}}</td>
              <td>{{props.item.leaveEntered}}</td>
              <td>{{props.item.approver.GivenName ? ([props.item.approver.GivenName,props.item.approver.Surname].join(' ')) : 'No Approver'}}</td>
              <td
                @mouseover="showapprover[props.item.id] = true"
                @mouseleave="showapprover[props.item.id] = false"
                :class="{'approved': props.item.approval.type == 'approved', 'warning': props.item.approval.type == 'pending approval', 'error': props.item.approval.type == 'null'}"
              >
                {{props.item.approval.text}}&nbsp;
                <span
                  v-if="showapprover[props.item.id]"
                >({{ props.item.approver.GivenName ? 'see ' + props.item.approver.GivenName : 'no approver' }})</span>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat v-if="Object.keys(props.item.leaves).length == 0">
              <v-card-text>No Leave Taken</v-card-text>
            </v-card>
            <v-card v-else>
              <v-card class="leaves"><strong>Leave summary for {{ props.item.name }} for period {{ fromDate | dateFormat }} to {{ toDate | dateFormat }}</strong></v-card>
              <v-card flat v-for="(leaves, j) in props.item.leaves" :key="j" @click="leaves.show = !leaves.show">
                <v-card-text class="leaves" >
                  Total <i>{{ leaves.name }}</i>: <b>{{ leaves.raw }}hrs raw. {{ leaves.raw * 0.95 }}hrs adj.</b>
                </v-card-text>
                <v-card flat v-for="(a, iA) in leaves.activities" :key="iA" v-show="leaves.show">
                  <v-card-text v-if="Object.keys(a).length > 0" class="leaves more-leave">
                    <b>{{ a.HoursWorked }}hrs -</b> {{ a.activity.Name }} taken on {{ a.WorkedOn | dateFormat }}
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    showapprover: {},
    applyClicked: false,
    userToEmail: null,
    emailDialog: false,
    expand: false,
    search: "",
    toDate: new Date(),
    fromDate: new Date(),
    headers: [
      { text: "Name", value: "name", align: "left", sortable: true },
      { text: "Days Worked", value: "days", sortable: true},
      { text: "Leave entered", value: "leaveEntered", sortable: true },
      { text: "Approver", value: "approver.GivenName", sortable: true },
      { text: "Approval State", value: "approval.text", sortable: true }
    ],
    users: [],
    filterActive: false,
    statusMap: {
      approved: "Approved",
      "pending approval": "Pending Approval",
      null: "Not Submitted/Rejected"
    },
    managers: []
  }),
  computed: {
    ...mapState("admin", ["pipefishUsers", "summary", "selectedDates"]),
    emailUsers: function() {
      return this.pipefishUsers.map(user => ({
        text: `${user.GivenName} ${user.Surname}`,
        value: user
      }));
    }
  },
  created() {
    if (this.pipefishUsers.length == 0) {
      this.getAllPipefishUsers();
    }
    this.managers = this.getManagers();
    if (this.summary.length != 0) {
      this.fillTable();
      this.toDate = this.selectedDates.to;
      this.fromDate = this.selectedDates.from;
    }
  },
  filters: {
    dateFormat(value) {
      return moment(value).format("dddd - DD/MM/YYYY");
    }
  },
  methods: {
    ...mapMutations("admin", ["setSummary", "setSelectedDates"]),
    ...mapActions("admin", ["setSortedPipefishUsers"]),
    gotoTimesheets(id, name) {
      this.$router.push({
        name: "Timesheets",
        params: {
          userId: {
            id: id,
            name: name
          }
        }
      });
    },
    getEntries() {
      this.applyClicked = true;
      var self = this;
      this.users = [];
      var start = new Date(moment(this.fromDate).utc(true).toString());
      var end = new Date(moment(this.toDate).utc(true).endOf('d').toString());
      // console.log(start + ' | ' + end);

      // Save the selected time frame
      var selected = {
        from: start,
        to: end
      };
      this.setSelectedDates(selected);

      this.$timesheetApi.getAllTimesheetEntries(selected.from, selected.to).then(entries => {
        self.setSummary(entries);
        self.fillTable();
        self.applyClicked = false;
      });
    },
    fillTable() {
      var groupedEntries = {};

      this.pipefishUsers
        .filter(user => user.IsActive != this.filterActive)
        .forEach(user => {
          groupedEntries[user.id] = {
            name: `${user.GivenName} ${user.Surname}`,
            id: user.id,
            entries: [],
            email: user.EmailAddress
          };
        });
      this.summary.forEach(el => {
        if (groupedEntries[el.UserAccountId]) {
          groupedEntries[el.UserAccountId].entries.push(el);
        }
      });
      for (var personId in groupedEntries) {
        var person = groupedEntries[personId];
        var row = this.calculateTableRow(person);
        this.users.push(row);
      }
    },
    calculateTableRow(person) {
      var self = this;
      const noLeaves = person.entries.filter(entry => !entry.activity.IsLeave);
      const leaves = person.entries.filter(entry => entry.activity.IsLeave);
      var totalLeaveEntered = leaves.length;
      var leaveObj = {};
      for(var l = 0; l < leaves.length; l++) {
        var leaveActivity = leaves[l].activityId
        if(typeof leaveObj[leaveActivity] == 'undefined') {
          leaveObj[leaveActivity] = {
            raw: 0,
            activities: [],
            name: leaves[l].activity.Name,
            show: false
          };
        }
        leaveObj[leaveActivity]['raw'] += leaves[l].HoursWorked;
        leaveObj[leaveActivity]['activities'].push(leaves[l]);
      }
      console.log(leaveObj);
      let approval = {
        type: "approved",
        text: self.statusMap["approved"]
      };
      let approver = [];
      if(self.managers) {
        approver = self.managers.filter(obj => {
          return obj.UserAccountId == person.id;
        });
      }
      if (approver.length == 0) {
        approver = {};
      } else {
        approver = approver[0].managedBy;
      }
      person.entries.forEach(entry => {
        if (!entry.approval) {
          approval = {
            type: "null",
            text: self.statusMap["null"]
          };
        }
        if (approval.type != "null") {
          if (entry.approval.Status == "pending approval") {
            approval = {
              type: entry.approval.Status,
              text: self.statusMap[entry.approval.Status]
            };
          }
        }
      });
      var totalHours = 0;
      for (var i = 0; i < noLeaves.length; i++) {
        var entry = noLeaves[i];
        totalHours += noLeaves[i].HoursWorked;
      }
      return {
        days: totalHours / 8,
        name: person.name,
        leaves: leaveObj,
        leaveEntered: totalLeaveEntered,
        id: person.id,
        email: person.email,
        approval: approval,
        approver: approver
      };
    },
    emailUser(email) {
      this.userToEmail = email;
      this.emailDialog = true;
    },
    getAllPipefishUsers() {
      var self = this;
      this.$timesheetApi.getAllUsers().then(users => {
        self.setSortedPipefishUsers(users);
      });
    },

    getManagers() {
      var self = this;
      self.$timesheetApi.getManagers().then(managers => {
        self.managers = managers;
      });
    }
  }
};
</script>

<style scoped>
.addAll {
  border: 1px solid grey;
  border-radius: 10px;
  padding: 5px;
}

.addAll:hover {
  background-color: #f5f5f5;
  cursor: pointer;
  opacity: 0.8;
}

td a {
  color: purple;
  font-weight: bold;
}
td a:hover {
  text-decoration: underline;
}
tr:hover {
  cursor: pointer;
}
.leaves:hover {
  background-color: #f5f5f5;
}

.leaves > strong {
  margin: 0px;
  padding: 15px;
  top: 10px;
  height: 20px;
  font-size: 14px;
  font-weight: 700;
}

table.v-table tbody td,
table.v-table tbody th {
  height: 10px;
}

.more-leave {
  margin-left: 30px;
}
</style>
